// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./examples/assets/index.less
// module id = 3
// module chunks = 0 1 2 4 6 7 8